// Curated Amalfi Coast luxury imagery (royalty-free)
export const IMAGES = {
  heroVilla: "/media/villa-hero.webp",
  positanoAerial: "/media/vf-d.webp",
  positanoDusk: "/media/vf-b.webp",
  infinityPool: "https://images.unsplash.com/photo-1765999906700-2d4dfd392966?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000&ixlib=rb-4.1.0",
  poolCliff: "https://images.unsplash.com/photo-1646519034169-fd82895985ff?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600&ixlib=rb-4.1.0",
  villaInterior: "/media/vf-e.webp",
  brightInterior: "/media/vf-a.webp",
  loungeInterior: "/media/vf-c.webp",
  terraceSunset: "/media/vf-b.webp",
  terraceView: "/media/vf-e.webp",
  yacht: "/media/vf-c.webp",
  sorrentoCliffs: "/media/vf-d.webp",
  amalfiVilla2: "/media/vf-b.webp",
};
